<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-red"
                                sub-title="350,897"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 3.48%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total traffic"
                                type="gradient-orange"
                                sub-title="2,356"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 12.18%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Sales"
                                type="gradient-green"
                                sub-title="924"
                                icon="ni ni-money-coins"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"><i class="fa fa-arrow-down"></i> 5.72%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>

                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Performance"
                                type="gradient-info"
                                sub-title="49,65%"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"><i class="fa fa-arrow-up"></i> 54.8%</span>
                            <span class="text-nowrap">Since last month</span>
                        </template>
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-12">
                                    <h4 class="font-weight-bold text-primary">My Shopping Orders</h4>
                                </div>
                            </div>
                        </div>
                        <div class="card-body p-5">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="orders"
                                    :pagination-options="{
                   enabled: true,
                   mode: 'pages',
                   perPage: 10
                 }"
                                    :search-options="{
                    enabled: true,
                    placeholder: 'Search this table',
                  }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'created'">
                                        <small>{{moment(props.row.created_at).format('MMMM Do YYYY, h:mm:ss a')}}</small>
                                    </span>
                                    <span v-if="props.column.field == 'statu'">
                                    <span v-if="props.row.product.status == 0" class="badge badge-danger">out of stock</span>
                                    <span v-if="props.row.product.status == 1" class="badge badge-success">in stock</span>
                                </span>
                                    <span v-else-if="props.column.field == 'action'">
                    <router-link :to="{path: '/MyshoppingOrderInfo/' + props.row.id}">
                        <button class="btn btn-success btn-sm"><i class="fa fa-eye"></i></button>
                    </router-link>
                </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    var moment = require('moment');
  export default {
    name: 'MyShoppingOrders',
    components: {

    },
      data(){
          return{
              moment,
              columns: [
                  {
                      label: 'Item',
                      field: 'product.title',
                  },
                  {
                      label: 'Price',
                      field: 'product.price'
                  },
                  {
                      label: 'Quantity',
                      field: 'quantity'
                  },
                  {
                      label: 'Date',
                      field: 'created',
                  },
                  {
                      label: 'Status',
                      field: 'statu'
                  },
                  {
                      label: 'Action',
                      field: 'action'
                  }
              ],
              orders: []
          }
      },
      methods:{
          getAllOrders(){
              this.axios.get("/retailer/dashboard/myOrders").then(({data}) => ([this.orders = data]));
          }
      },
      created() {
          this.getAllOrders();
      }
  };
</script>
<style></style>
